import { VueConstructor } from 'vue';

import { humanReadableDate } from '~common-filters/humanReadableDate';
import { humanReadableFieldValue } from '~common-filters/humanReadableFieldValue';

export const MainPlugin = {
    install(Vue: VueConstructor) {
        Vue.config.productionTip = false;

        // filter imports
        Vue.filter('humanReadableDate', humanReadableDate);
        Vue.filter('humanReadableFieldValue', humanReadableFieldValue);

        // themed components
        Vue.component('ThemedButton', () => import(/* webpackChunkName: "themed-components-bundle" */ '~common-components/ThemedComponents/ThemedButton.vue'));
        Vue.component('ThemedSheet', () => import(/* webpackChunkName: "themed-components-bundle" */ '~common-components/ThemedComponents/ThemedSheet.vue'));
        Vue.component('ThemedCard', () => import(/* webpackChunkName: "themed-components-bundle" */ '~common-components/ThemedComponents/ThemedCard.vue'));
        Vue.component('ThemedIcon', () => import(/* webpackChunkName: "themed-components-bundle" */ '~common-components/ThemedComponents/ThemedIcon.vue'));

        // layout components
        Vue.component('Popup', () => import(/* webpackChunkName: "popup" */ '~common-components/Popup/index.vue'));
    },
};

export default MainPlugin;
